import React, { useState, useEffect, useRef } from "react";
import '../../../../App.css';
import Header from "../../../../Components/Header/Header.js";
import LeftMenu from "../../../../Components/LeftMenu/LeftMenu.js";
import TopMenu from "../../../../Components/TopMenu/TopMenu.js";
// import CargoDamage from "../CargoDamage/CargoDamage";
// import JGrid from "../../Components/JGrid/JGrid";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt, faChevronLeft, faChevronRight,
    faXmark, faBolt, faPaperclip, faChevronDown,
    faPlus, faMinus, faMagnifyingGlass, faArrowLeft, faPlane
} from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { Button, Dropdown, Form, ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Timeline } from 'vis-timeline/standalone';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import { MultiSelect } from 'react-multi-select-component';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
// import JGrid from "../../Components/JGrid/JGrid";
// import JGrid from './JGrid';
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Plane from "../../../../assets/images/plane.svg";
import Planemap from "../../../../assets/images/plane_map.png";
import Planedash from "../../../../assets/images/plane_dash.png";
import Truckdash from "../../../../assets/images/truck_dash.png";
import Filter from "../../../../assets/images/filter_new.png";
import { Tab, Tabs } from 'react-bootstrap';

import ImageUpload from '../../../../Components/common/ImageUpload.js';
import ActivityComments from '../../../../Components/common/ActivityComments.js';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERSDETAILS } from '../../../../Utils/conts.js';


const HandlerMonitor = () => {
    const isMounted = useRef(false);
    const childRef = useRef();
    const options = [];
    const [formData, setFormData] = useState();
    const [isOpened, setIsOpened] = useState(false);
    // const [show, setShow] = useState(false);

    //   const handleClose = () => setShow(false);
    //   const handleShow = () => setShow(true);

    const [selectedButton, setSelectedButton] = useState('Loading');

    const handleButtonClick = (button) => {
        setSelectedButton(button);
        fetchTruckData(button)
        fetchStationData(button)
    };

    const [selectedDate, setSelectedDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);

    const toggleCalendar = () => {
        setShowCalendar(!showCalendar);
    };

    const handleSelect = date => {
        setSelectedDate(date);
        setShowCalendar(false); // Close the calendar when a date is selected

        // Update the timeline to display the selected date
        const timelineStart = new Date(date);
        timelineStart.setHours(0, 0, 0, 0); // Start of the day
        const timelineEnd = new Date(date);
        timelineEnd.setHours(23, 59, 59, 999); // End of the day

        if (timeline) {
            timeline.setOptions({
                start: timelineStart,
                end: timelineEnd,
            });
        }
        // END
        // Highlight the selected date in the custom calendar
        const calendar = document.querySelector('.scrollable-calendar');
        const days = calendar.querySelectorAll('.day');
        days.forEach((day) => {
            day.classList.remove('active');
        });

        const formattedDate = date.toISOString().split('T')[0];
        const matchingDay = Array.from(days).find((day) => {
            const dayDate = new Date(
                `${day.querySelector('.date').textContent}, ${new Date().getFullYear()}`
            );
            return dayDate.toISOString().split('T')[0] === formattedDate;
        });

        if (matchingDay) {
            matchingDay.classList.add('active');
        }
    };

    const [currentDate, setCurrentDate] = useState(new Date());
    const daysToShow = 7;

    function handleNext() {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + daysToShow);
        setCurrentDate(newDate);
    }

    function handlePrevious() {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - daysToShow);
        setCurrentDate(newDate);
    }

    function isCurrentDate(date) {
        const today = new Date();
        return date.toDateString() === today.toDateString();
    }

    function getDayName(date) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return days[date.getDay()];
    }

    function getMonthAbbreviation(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[date.getMonth()];
    }

    const getStartDate = () => {
        const startDate = new Date(currentDate);
        startDate.setDate(currentDate.getDate() - 3); // 3 days before currentDate
        return startDate;
    };

    const handleDayClick = async (date, event) => {

        // console.log('date');
        const calendar = document.querySelector('.scrollable-calendar');
        const days = calendar.querySelectorAll('.day');
        days.forEach(day => {
            day.classList.remove('active');
        });
        event.currentTarget.classList.add('active');
        // if (!apiData) {
        //   console.error('API data is not available');
        //   return;
        // }
        // Convert the date to the format "YYYY-MM-DD"
        const formattedDate = date.toISOString().split('T')[0];
        const dateObject = new Date(date);
        const datePart = dateObject.toISOString().split("T")[0];

        setSelectedDate(date);  // Store the selected date
        if (childRef.current) {
            childRef.current.handleCloseClick();
        }

        // Update the timeline
        const timelineStart = new Date(date);
        timelineStart.setHours(0, 0, 0, 0); // Start of the day
        const timelineEnd = new Date(date);
        timelineEnd.setHours(23, 59, 59, 999); // End of the day

        if (timeline) {
            timeline.setOptions({
                start: timelineStart,
                end: timelineEnd,
            });
        }
    };


    // TIMELINE START 
    const loadingTimelineRef = useRef(null);
    const unloadingTimelineRef = useRef(null);

    const timelineRef = useRef(null);
    const svgRef = useRef(null);
    const [selectedFlightDetails, setSelectedFlightDetails] = useState();
    const [showFlightDetails, setShowFlightDetails] = useState(false);
    const [filteredItems, setFilteredItems] = useState([]);
    const [flightGroup, setFlightGroup] = useState([]);
    const [clickedFlight, setClickedFlight] = useState(null); // Store the clicked flight ID
    const [currentTime, setCurrentTime] = useState(new Date());
    const [timeline, setTimeline] = useState(null);
    const [timelineDisplay, setTimelineDisplay] = useState('T');
    const [getLoadingData, setGetLoadingData] = useState([]);
    const [getUnloadingData, setGetUnloadingData] = useState([]);
    const [disLoading, setDisLoading] = useState(false);
    const [connections, setConnections] = useState([]);
    const [getStation, setGetStation] = useState([]);
    const [selectedStation, setSelectedStation] = useState([]);

    const [activeTab, setActiveTab] = useState('Loading');
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        fetchTruckData()
    }

    const [groups, setGroups] = useState([]);
    const fetchStationData = async (id) => {
        try {
            const res = await withRFSToken.post(`monitor/vehicle-dashboard-stations`, { tab_name: id }) // &station_name=null
                .then(function (res) {
                    const innerData = res.data.response_data;
                    console.log("🚀 ~ innerData:", innerData)
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item,
                        label: item,
                    })) : [];
                    setGetStation(innerData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const fetchTruckData = async (id, stn) => {
        try {
            const res = await withRFSToken.get(`monitor/vehicle-dashboard-view?tab_name=${id ? id : selectedButton}&station_name=${stn ? stn : ''}`, {}) // &station_name=null
                .then(function (res) {
                    const innerData = res.data;
                    console.log("🚀 ~ innerData:", innerData)
                    if (id === 'Loading') {
                        setGetLoadingData(innerData);
                        // groups = innerData.group_data;
                        setGroups(innerData.station_name);
                    } else if (id === 'Unloading') {
                        setGetUnloadingData(innerData);
                    } else {
                        groups = [
                            { id: 1, content: 'AMS' },
                            { id: 2, content: 'FRA' },
                            { id: 3, content: 'CDG' },
                            { id: 4, content: 'LHR' },
                            { id: 5, content: 'AAG' },
                            { id: 6, content: 'CGO' },
                        ];
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        fetchStationData(selectedButton)
        fetchTruckData(selectedButton);
        isMounted.current = true;
    }, []);

    const [isDataReady, setIsDataReady] = useState(false);

    const handleFilter = () => {
        if (selectedStation.length > 0) {
            const groups = selectedStation.map(item => ({
                id: item.value,
                content: item.label,
            }));
            setGroups(groups)
        } else {
            const groups = getStation.map(item => ({
                id: item.value,
                content: item.label,
            }));
            setGroups(groups)
        }
        setIsDataReady(false);
    }

    const formatDate = (dateString) => {
        if (!dateString) return ''; // Handle undefined or null dates
        const [day, month, yearAndTime] = dateString.split('-');
        const [year, time] = yearAndTime.split(' ');
        return `${year}-${month}-${day} ${time}`;
    };

    const truckDetailsForFlight = [
        { id: 7, group: 'Truck 1', content: 'ZZZ-152A', start: '2024-10-13 05:00', end: '2024-10-13 20:25', flightId: 1, className: 'bg-green' },
        { id: 8, group: 'Truck 2', content: 'ZZZ-722B', start: '2024-10-13 02:00', end: '2024-10-13 21:35', flightId: 1, className: 'bg-green' },
        { id: 9, group: 'Truck 3', content: 'ZZZ-612A', start: '2024-10-13 13:00', end: '2024-10-13 06:35', flightId: 2, className: 'bg-blue' },
        { id: 10, group: 'Truck 4', content: 'ZZZ-422', start: '2024-10-14 07:00', end: '2024-10-14 16:05', flightId: 3, className: 'bg-green' },
        { id: 11, group: 'Truck 5', content: 'ZZZ-681A', start: '2024-10-14 09:00', end: '2024-10-14 20:10', flightId: 4, className: 'bg-green' },
        { id: 12, group: 'Truck 6', content: 'ZZZ-925B', start: '2024-10-17 20:15', end: '2024-10-17 05:25', flightId: 5, className: 'bg-blue' },
    ];

    const truckGroups = [
        { id: 'Truck 1', content: 'Truck 1' },
        { id: 'Truck 2', content: 'Truck 2' },
        { id: 'Truck 3', content: 'Truck 3' },
        { id: 'Truck 4', content: 'Truck 4' },
        { id: 'Truck 5', content: 'Truck 5' },
        { id: 'Truck 6', content: 'Truck 6' },
    ];

    const drawConnections = () => {
        const svg = svgRef.current;
        if (!svg) return;

        svg.innerHTML = ""; // Clear previous SVG paths

        filteredItems?.forEach((item) => {
            // Find the flight element by its data-id
            const flightElement = document.querySelector(`.vis-item.flight`);
            if (!flightElement) {
                // console.warn(`Flight element with id flight-${item.id} not found`);
                return; // Skip drawing if the flight element is missing
            }

            const flightRect = flightElement.getBoundingClientRect();
            const flightX = flightRect.left; // X-coordinate of the left line
            const flightY = flightRect.top + flightRect.height / 2; // Middle of the left line

            // Iterate over the trucksList for this flight
            item.trucksList.forEach((truck, trindex) => {
                const truckElements = document.querySelectorAll('.vis-item.truck'); // All truck elements
                const truckElement = truckElements[trindex]; // Get the truck element corresponding to this index

                if (!truckElement) return;

                const truckRect = truckElement.getBoundingClientRect();
                const truckX = truckRect.left + truckRect.width;
                const truckY = truckRect.top + truckRect.height / 2;

                // Create an SVG path for each truck
                const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                const verticalOffset = Math.abs(flightY - truckY) / 10;
                const isPositive = truckY - flightY > 0;

                const pathData = isPositive
                    ? `M ${flightX},${flightY} 
                           C ${flightX - 50},${flightY + verticalOffset} 
                             ${truckX + 50},${truckY + verticalOffset} 
                             ${truckX},${truckY}`
                    : `M ${flightX},${flightY} 
                           C ${flightX - 50},${flightY - verticalOffset} 
                             ${truckX + 50},${truckY - verticalOffset} 
                             ${truckX},${truckY}`;

                path.setAttribute("d", pathData);
                path.setAttribute("fill", "none");
                path.setAttribute("stroke", "black");
                path.setAttribute("stroke-width", "2");

                svg.appendChild(path);
            });
        });
    };

    const generateTimelineItems = (data) =>
        data.map((item, index) => ({
            id: index + 1,
            // group,
            order_id: item.order_id,
            content: `<div><img src="${Truckdash}" alt="Plane" /><span> ${item.vehicle_no}</span><p>${item.actual_start_date?.split(' ')[1]} - ${item.actual_end_date?.split(' ')[1]}</p></div>`,
            start: formatDate(item.actual_start_date),
            end: formatDate(item.actual_end_date),
            className: 'dashbord_blu',
        }));

    useEffect(() => {
        if (!selectedButton) return;

        const currentTime = new Date();
        const timelineStart = new Date(currentTime);
        timelineStart.setHours(0, 0, 0, 0);
        const timelineEnd = new Date(currentTime);
        timelineEnd.setHours(23, 59, 59, 999);

        const options = {
            stack: true,
            margin: { item: 10, axis: 10 },
            start: timelineStart,
            end: timelineEnd,
            editable: false,
            zoomable: true,
            horizontalScroll: true,
            itemHeight: 51,
            minHeight: "85dvh",
            orientation: { axis: "both", item: "bottom" },
            zoomMax: 21600000, // 6 hours in milliseconds
        };

        let timelineInstance;
        if (selectedButton === "Loading" && loadingTimelineRef.current) {
            timelineInstance = new Timeline(loadingTimelineRef.current, generateTimelineItems(getLoadingData), options);
        } else if (selectedButton === "Unloading" && unloadingTimelineRef.current) {
            timelineInstance = new Timeline(unloadingTimelineRef.current, generateTimelineItems(getUnloadingData), options);
        }

        setTimeline(timelineInstance);

        return () => timelineInstance?.destroy();
    }, [selectedButton, getLoadingData, getUnloadingData]);




    const handleSidePanelClick = async (item) => {
        // console.log('item', item);
        if (!showFlightDetails) {
            if (timelineDisplay === 'F') {
                setSelectedFlightDetails(item);
            } else {
                setDisLoading(true);
                try {
                    const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: item.order_id })
                        .then(function (res) {
                            const innerData = res.data.response_data;
                            setSelectedFlightDetails(innerData);
                            setDisLoading(false);
                        });
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        }
    }

    const detailsClick = () => {

        setFilteredItems([selectedFlightDetails]);
        setShowFlightDetails(true);
        setClickedFlight(selectedFlightDetails);
        setSelectedFlightDetails(null);

        const fromId = selectedFlightDetails.trucksList[0]?.id;
        const toConnections = selectedFlightDetails.trucksList.slice(1).map((item) => ({
            from: fromId,
            to: item.id,
        }));
    }
    // console.log('timeline', timeline);
    const DisplayChange = (event) => {
        // setShowFlightDetails(false);
        // setFilteredItems(null);
        // setTimelineDisplay(event.target.value);
        // setSelectedFlightDetails()
        fetchTruckData(selectedButton, event.target.value)
    }
    // const handleSortBy = (event) => {
    //     const sortBy = event.target.value;

    // }

    const zoomIn = () => {
        if (timeline) {
            const range = timeline.getWindow();
            const interval = range.end - range.start;
            timeline.setWindow({
                start: new Date(range.start.getTime() + interval * 0.1), // Zoom in 10%
                end: new Date(range.end.getTime() - interval * 0.1),
            });
        }
    };

    // Function to zoom out
    const zoomOut = () => {
        if (timeline) {
            const range = timeline.getWindow();
            const interval = range.end - range.start;
            timeline.setWindow({
                start: new Date(range.start.getTime() - interval * 0.1), // Zoom out 10%
                end: new Date(range.end.getTime() + interval * 0.1),
            });
        }
    };


    const findItemByContent = (container, content) => {
        const items = container.querySelectorAll(".vis-item");
        return Array.from(items).find((item) => item.textContent?.includes(content));
    };


    const handleCloseClick = () => {
        setSelectedFlightDetails(null);
    };



    // FILE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };
    // FILE UPLOAD END


    return (
        <>
            {console.log('allItems', selectedStation)}
            {/* {console.log('timeline', timeline)} */}
            {console.log('groups', groups)}
            <div className="dashboard">
                <Header logo_url='/HandlerTruckMonitor' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mb-3">
                            <button className={selectedButton === 'Loading' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('Loading')}>
                                <span> Loading </span>
                            </button>
                            <button className={selectedButton === 'Unloading' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('Unloading')}>
                                <span> Unloading </span>
                            </button>
                        </div>
                        <div className="mainTab d-flex justify-content-between align-items-center">
                            <div className="nestedtabs rounded">
                                <div className='d-flex'>
                                    <div>
                                        <div style={{ position: 'relative' }}>
                                            <div onClick={toggleCalendar} className='clendericon'>
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </div>
                                            {showCalendar && (
                                                <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 9999, }}>
                                                    <DatePicker
                                                        selected={selectedDate}
                                                        onChange={handleSelect}
                                                        inline
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="calendar-container schedule_calender">
                                        <div className="scrollable-calendar">
                                            <button className='btnleft' onClick={handlePrevious}> <FontAwesomeIcon icon={faChevronLeft} /> </button>
                                            {[...Array(daysToShow)].map((_, index) => {
                                                const date = new Date(getStartDate());
                                                date.setDate(getStartDate().getDate() + index);
                                                return (
                                                    <div key={index} className={`day ${isCurrentDate(date) ? 'current-date' : ''}`} onClick={(event) => handleDayClick(date, event)}>
                                                        <div className="day-name">{getDayName(date)}</div>
                                                        <div className="date"> {getMonthAbbreviation(date)} {date.getDate()}</div>
                                                    </div>
                                                );
                                            })}
                                            <button className='btnright' onClick={handleNext}> <FontAwesomeIcon icon={faChevronRight} /> </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-end truck_filter">

                                <div className="d-flex tuck_short">

                                    <Form.Group className="me-2">{console.log('getStation', getStation)}
                                        <Form.Label>Station</Form.Label>
                                        <Form.Select aria-label="Select" onChange={(event) => DisplayChange(event)}>
                                            <option value="0">Select</option>
                                            {getStation?.map((stn) => (
                                                <option value={stn}>{stn}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    {/* <Form.Group >
                                        <Form.Label>Sort By</Form.Label>
                                        <Form.Select aria-label="Select" onChange={(event) => handleSortBy(event)}>
                                            <option>Sorted by Origin</option>
                                            <option value="L">Loading Station</option>
                                            <option value="U">Unloading Station</option>
                                        </Form.Select> */}
                                    {/* <MultiSelect
                                            options={getStation}
                                            // value={getStation.filter(item => formData.unloading_station?.includes(item.station_id))}
                                            value={selectedStation}
                                            onChange={setSelectedStation}
                                            labelledBy="Select "
                                            className='multiselect'
                                            disabled = {timelineDisplay !== 'T' ? true : ''}
                                        />
                                    </Form.Group> */}


                                </div>
                                {/* <div className="ms-2"><button type="button" className="btn btn-primary truck_search" onClick={handleFilter}><FontAwesomeIcon icon={faMagnifyingGlass} /> Search</button></div> */}


                                {/* <div className="chart_filter ms-2" > <Link to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight2" aria-controls="offcanvasRight"> <img src={Filter} ></img> </Link> </div>

                                <div className="offcanvas offcanvas-end dashbord_side" tabindex="-1" id="offcanvasRight2" aria-labelledby="offcanvasRightLabel">
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    <div className="offcanvas-header rafilter">
                                        <h3>Filter Properties</h3>
                                        <p>Select Properties that you want to see inside the chart</p>
                                    </div>
                                    <div className="offcanvas-body">

                                        <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Loading Station</Form.Label>
                                            <Form.Select aria-label="Default select example">
                                                <option>Open this select menu</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Unloading Station</Form.Label>
                                            <Form.Select aria-label="Default select example">
                                                <option>Open this select menu</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Form.Group>


                                        <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Trucker Name</Form.Label>
                                            <Form.Select aria-label="Default select example">
                                                <option>Open this select menu</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <div className='text-center filter_update'>
                                            <Button variant="light" className='stk_cancel' >CANCEL</Button>
                                            <Button variant="primary" className='stk_save posr' >UPDATE</Button>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="ms-2 truck_plas">
                                    <button type="button" className="btn btn-light" onClick={zoomOut}> <FontAwesomeIcon icon={faMinus} /> </button>
                                    <button type="button" className="btn btn-light ms-2" onClick={zoomIn}><FontAwesomeIcon icon={faPlus} /></button>

                                </div>


                            </div>
                            {/* <CargoDamage />                        */}
                        </div>
                        <div className="maindiv mt-3">
                            <div className='trashdonload'>
                                {/* <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                                    <Tab eventKey="Loading" title={<span>Loading </span>} className='moveto'> */}
                                {selectedButton === 'Loading' && <div className=' nestedtabs rounded trashdonload' ><div ref={loadingTimelineRef}></div></div>}

                                {/* </Tab>
                                    <Tab eventKey="Unloading" title={<span>Unloading </span>} className='moveto'> */}
                                {selectedButton === 'Unloading' && <div className=' nestedtabs rounded trashdonload' ><div ref={unloadingTimelineRef}></div></div>}
                                {/* </Tab>
                                </Tabs> */}
                            </div>
                        </div>

                        <div className={`maindiv mt-3 overflow-hidden ${timelineDisplay == 'T' ? 'position-relative' : ''}`}>
                            {disLoading &&
                                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                            }
                            {selectedFlightDetails && (
                                <div className="SecondDiv">
                                    {/* {console.log('selectedFlightDetails', selectedFlightDetails)} */}
                                    <button className="close" onClick={handleCloseClick}>
                                        <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                    <div className="girddtals_header">
                                        <h3>{timelineDisplay === 'T' ? selectedFlightDetails.truck_number : selectedFlightDetails.content}</h3>
                                        <div className='d-flex actbtn'>

                                            <Button variant="light" > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>{/* onClick={browseClick} */}
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                                    <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item>Option</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {timelineDisplay == 'F' ?
                                                <Button variant="light" onClick={detailsClick}> <FontAwesomeIcon icon={faPaperclip} /> Details</Button>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-between my-3'>
                                        <div className='order_view'>
                                            <h3>{selectedFlightDetails.loading_station}</h3>
                                            {/* <span>{selectedFlightDetails.loading_name}</span> */}
                                            <span>
                                                {selectedFlightDetails.loading_name && selectedFlightDetails.loading_name.length > 20
                                                    ? `${selectedFlightDetails.loading_name.slice(0, 20)}...`
                                                    : selectedFlightDetails.loading_name}
                                            </span>
                                            <div className='mt-3'>
                                                <p>Scheduled - <b>{selectedFlightDetails.loading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                                <p>Actual - <b>{selectedFlightDetails.loading_date_actual} <span></span></b> {/*CEST*/}</p>
                                            </div>
                                        </div>
                                        <div className='order_middle'>
                                            <p><img src={Cargotruck} /></p>
                                            <span>{selectedFlightDetails.truck_number}</span>
                                        </div>
                                        <div className='order_view'>
                                            <h3>{selectedFlightDetails.unloading_station}</h3>
                                            {/* <span>{selectedFlightDetails.unloading_name}</span> */}
                                            <span>
                                                {selectedFlightDetails.unloading_name && selectedFlightDetails.unloading_name.length > 20
                                                    ? `${selectedFlightDetails.unloading_name.slice(0, 20)}...`
                                                    : selectedFlightDetails.unloading_name}
                                            </span>
                                            <div className='mt-3'>
                                                <p>Scheduled - <b>{selectedFlightDetails.unloading_date_scheduled} <span></span></b> {/*CEST*/}</p>
                                                <p>ETA - <b>{selectedFlightDetails.unloading_date_actual} <span></span></b> {/*CEST*/}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='mb-3'>
                                        <ProgressBar animated now={50} style={{ height: "5px" }} />
                                    </div>
                                    {timelineDisplay == 'T' ?
                                        <>
                                            <div className='movment_history'>
                                                <h3>Status Updates</h3> {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                                            </div>
                                            <div className='movment_list'>
                                                <ul>
                                                    {selectedFlightDetails && selectedFlightDetails?.status_updates.map((history, index) => (
                                                        <li>
                                                            <span className='movem w-auto'>{history.status}</span>
                                                            <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                                                            {/* <Link to='#' >Details</Link> onClick={() => handleDetailsClick(history)} */}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                        :
                                        <div className="planemap">
                                            <img src={Planemap} />
                                        </div>
                                    }
                                    <ImageUpload
                                        ref={imageUploadRef}
                                        attachable_type={"uld"}
                                        attachable_id={selectedFlightDetails.uld_number}
                                        attachments={selectedFlightDetails.attachments}
                                    // onDeleteSuccess={() => loadDetails(selectedFlightDetails.uld_number)}
                                    />
                                    <ActivityComments
                                        commentable_type={"uld"}
                                        commentable_id={selectedFlightDetails.uld_number}
                                        allactivities={selectedFlightDetails.activities}
                                    // onReloadDetails={loadDetails}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >

        </>
    );

}
export default HandlerMonitor;